import { render, staticRenderFns } from "./Error-component.vue?vue&type=template&id=5335a78e&"
import script from "./Error-component.vue?vue&type=script&lang=js&"
export * from "./Error-component.vue?vue&type=script&lang=js&"
import style0 from "./Error-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
